import { createSlice } from '@reduxjs/toolkit';

const tasksSlice = createSlice({
    name: 'tasks',
    initialState: {
        tasks: {}, // Group tasks by status
        parents: [],
    },
    reducers: {
        setTasks(state, action) {
            state.tasks = action.payload;
        },
        addTask(state, action) {
            const { status } = action.payload;
            if (!state.tasks[status]) {
                state.tasks[status] = [];
            }
            state.tasks[status].push(action.payload); // Add to the appropriate status group
        },
        deleteTask(state, action) {
            const taskId = action.payload;
            for (const status in state.tasks) {
                state.tasks[status] = state.tasks[status].filter((task) => task.id !== taskId);
            }
        },
        editTask(state, action) {
            const updatedTask = action.payload;
            for (const status in state.tasks) {
                const index = state.tasks[status].findIndex((task) => task.id === updatedTask.id);
                if (index !== -1) {
                    state.tasks[status][index] = updatedTask;
                }
            }
        },
        setParents(state, action) {
            state.parents = action.payload;
        },
        addParent(state, action) {
            if (!state.parents.includes(action.payload)) {
                state.parents.push(action.payload);
            }
        },
        deleteParent(state, action) {
            state.parents = state.parents.filter((parent) => parent !== action.payload);
        },

    },
});

export const {
    setTasks,
    addTask,
    deleteTask,
    editTask,
    setParents,
    addParent,
    deleteParent,
} = tasksSlice.actions;

export default tasksSlice.reducer;
